export default __webpack_public_path__ + "static/media/events-not-selected.0ad17c71.svg";